export var ChainflipNetwork;
(function (ChainflipNetwork) {
    ChainflipNetwork["Bitcoin"] = "Bitcoin";
    ChainflipNetwork["Ethereum"] = "Ethereum";
    ChainflipNetwork["Arbitrum"] = "Arbitrum";
    ChainflipNetwork["Solana"] = "Solana";
})(ChainflipNetwork || (ChainflipNetwork = {}));
